// Will return select one from the options map based on the numeric value
// Valid keys are 'zero', 'one' or 'other'.

const pluralSelect = (value, { zero, one, other }) => {
    if (value === 0 && zero !== undefined) {
        return zero;
    } else if (value === 1 && one !== undefined) {
        return one;
    } else if (other !== undefined) {
        return other;
    } else {
        return '';
    }
};

export default pluralSelect;



// WEBPACK FOOTER //
// ./src/web/js/contest/utils/plural-select.js